import styled from "styled-components";
import { transparentize } from "polished";

export const Language = styled.div`
    background-color: ${p => p.theme.c.cardBackground};
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
    padding: 12px;
    border-radius: 12px;
    margin-bottom: 20px;
`;

export const LanguageActions = styled.div`
    display: flex;
    align-items: center;

    flex-wrap: wrap;

    h3 {
        margin: 0;
        display: flex;
        margin-bottom: 4px;
        margin-right: 10px;
    }
    button.button,
    a.button {
        margin-bottom: 0;
        margin-right: 12px;
        font-size: 12px;
        padding: 4px 8px;
        border-width: 1px;
    }

    a.button {
        height: 25px;
        line-height: 16px;
    }
`;

export const Members = styled.div`
    margin-top: 6px;

    hr {
        margin-top: 8px;
        margin-bottom: 4px;
        height: 2px;
        border: none;
        background-color: ${p => p.theme.c.greyE};
    }
`;

export const MembersTitle = styled.div`
    font-weight: 600;
    margin: 0;
    margin-bottom: 4px;
`;

export const Flag = styled.img`
    width: 40px;
    height: 28px;
    margin-right: 12px;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
`;

export const Info = styled.div`
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 4px;
`;

export const UsersWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -8px;
    margin-top: 12px;
`;

export const UserWrapper = styled.div`
    padding: 6px;
    background-color: ${p => transparentize(0.85, p.theme.c.active)};
    border-radius: 40px;
    margin-right: 8px;
    margin-bottom: 8px;
    [class^="User__UserImage"] {
        margin-right: 6px;
    }
`;

export const P = styled.p`
    font-size: 16px;
`;
